import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";
import { FuseSharedModule } from "@fuse/shared.module";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { LeafletModule } from "@bluehalo/ngx-leaflet";
import { AuthGuard } from "app/guards/auth.guard";

import { MapComponent } from "./map.component";

const routes = [
    {
        path: "map",
        component: MapComponent,
        canActivate: [AuthGuard],
    },
];

@NgModule({
    declarations: [MapComponent],
    imports: [RouterModule.forChild(routes), TranslateModule, FuseSharedModule, FuseWidgetModule, LeafletModule, FormsModule],
    exports: [MapComponent],
})
export class MapModule {}
